import { useEffect, useRef } from 'react'
import { useNavigate, useRouter } from '@tanstack/react-router'

import { clearToken } from '@/lib/auth'
import { Button } from '@/ui/button'

export class IdentityUnavailableError extends Error {
  constructor() {
    super('The signed-in identity could not be loaded')
  }
}

export function IdentityUnavailable() {
  const router = useRouter()
  const navigate = useNavigate()
  const headingRef = useRef<HTMLHeadingElement>(null)

  useEffect(() => {
    headingRef.current?.focus()
  }, [])

  const signOut = async () => {
    if (await clearToken()) return
    await navigate({ to: '/auth/login' })
  }

  return (
    <main className="bg-background flex min-h-screen flex-col items-center justify-center gap-2 p-6 text-center">
      <h1
        ref={headingRef}
        tabIndex={-1}
        className="font-heading text-foreground text-base font-medium focus:outline-none"
      >
        The service is unavailable
      </h1>
      <p className="text-muted-foreground text-sm">
        We couldn’t load your account. Try again in a moment.
      </p>
      <div className="mt-2 flex gap-2">
        <Button onClick={() => void router.invalidate()}>Try again</Button>
        <Button variant="outline" onClick={() => void signOut()}>
          Sign out
        </Button>
      </div>
    </main>
  )
}
